import React, { useEffect, useState } from "react";
import { oracleApi } from "@/api/oracleClient";

export default function KnowledgeGraphPanel() {
  const [items, setItems] = useState([]);
  const [selected, setSelected] = useState(null);
  const [detail, setDetail] = useState(null);
  const [loading, setLoading] = useState(false);

  const loadTop = async () => {
    try {
      const { data } = await oracleApi.graphTop(10);
      setItems(data?.top || []);
    } catch {
      setItems([]);
    }
  };

  useEffect(() => {
    loadTop();
  }, []);

  const drillDown = async (symbol) => {
    setSelected(symbol);
    setLoading(true);
    try {
      const { data } = await oracleApi.graphAsset(symbol);
      setDetail(data);
    } catch {
      setDetail(null);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="kg-panel" data-testid="kg-panel">
      <div className="kg-panel__head">
        <h4>Top Analyzed Assets (Cross-Session)</h4>
        <button
          type="button"
          className="oracle-btn oracle-btn--ghost oracle-btn--sm"
          onClick={loadTop}
        >
          ↻ Refresh
        </button>
      </div>
      {items.length === 0 && (
        <div className="oracle-empty" style={{ padding: 20 }}>
          No cross-session data yet. Run a few queries to build the graph.
        </div>
      )}
      {items.length > 0 && (
        <table className="kg-table">
          <thead>
            <tr>
              <th>Symbol</th>
              <th>Mentions</th>
              <th>Avg Confidence</th>
              <th>Modes</th>
              <th>Last Seen</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {items.map((it) => (
              <tr key={it.symbol}>
                <td><b>{it.symbol}</b></td>
                <td>{it.mentions}</td>
                <td>{it.avg_confidence}/10</td>
                <td>{(it.modes || []).join(", ")}</td>
                <td>{it.last_seen ? new Date(it.last_seen).toLocaleString() : "—"}</td>
                <td>
                  <button
                    type="button"
                    className="oracle-btn oracle-btn--ghost oracle-btn--sm"
                    onClick={() => drillDown(it.symbol)}
                    data-testid={`kg-drill-${it.symbol}`}
                  >
                    Open
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      {selected && (
        <div className="kg-detail">
          <div className="kg-detail__head">
            <h4>{selected} · Cross-Session Profile</h4>
            <button
              type="button"
              className="oracle-btn oracle-btn--ghost oracle-btn--sm"
              onClick={() => { setSelected(null); setDetail(null); }}
            >
              Close
            </button>
          </div>
          {loading && <div className="oracle-empty">Loading…</div>}
          {detail && (
            <div className="kg-detail__grid">
              <div className="rc-card">
                <div className="rc-card__label">Mentions</div>
                <div className="rc-card__value">{detail.mentions}</div>
              </div>
              <div className="rc-card">
                <div className="rc-card__label">Latest Verdict</div>
                <div className="rc-card__value">{detail.latest_verdict || "—"}</div>
              </div>
              <div className="rc-card">
                <div className="rc-card__label">Avg Confidence</div>
                <div className="rc-card__value">{detail.avg_confidence ?? "—"}/10</div>
              </div>
              <div className="rc-card">
                <div className="rc-card__label">Modes Seen</div>
                <div className="rc-card__value" style={{ fontSize: 14 }}>
                  {Object.entries(detail.modes_seen || {}).map(([k, v]) => `${k}×${v}`).join(", ") || "—"}
                </div>
              </div>
              <div className="rc-card" style={{ gridColumn: "1 / -1" }}>
                <div className="rc-card__label">Verdict Timeline</div>
                <div className="kg-timeline">
                  {Object.entries(detail.verdict_timeline || {}).map(([k, v]) => (
                    <span key={k} className={`kg-bar kg-bar--${k.toLowerCase()}`}>
                      <span className="kg-bar__label">{k}</span>
                      <span className="kg-bar__count">{v}</span>
                    </span>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
